import {enableProdMode} from '@angular/core';

import { environment } from './environments/environment';
import {bootstrapApplication} from "@angular/platform-browser";


import {appConfig} from "./app/app.config";
import {RootComponent} from "@olivades/pattern-lib";



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(RootComponent, appConfig).catch(err => console.error(err));
